import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "categories" */ './components/Categories.vue')
    },
    {
      path: '/categories',
      name: 'categories',
      component: () => import(/* webpackChunkName: "categories" */ './components/Categories.vue')
    },
    {
      path: '/challenges',
      name: 'challenges',
      component: () => import(/* webpackChunkName: "challenges" */ './components/Challenges.vue'),
      props: (route) => ({
        category: route.query.category
      })
    },
    {
      path: '/challenge-details',
      name: 'challengeDetails',
      component: () => import(/* webpackChunkName: "challengeDetails" */ './components/ChallengeDetails.vue'),
      props: (route) => ({
        id: route.query.id
      })
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './components/Login.vue'),
      props: true
    },
    {
      path: '/post',
      name: 'post',
      component: () => import(/* webpackChunkName: "post" */ './components/Post.vue'),
      props: (route) => ({
        challenge: route.query.challenge
      })
    },
    {
      path: '/post-details',
      name: 'postDetails',
      component: () => import(/* webpackChunkName: "postDetails" */ './components/PostDetails.vue'),
      props: (route) => ({
        id: route.query.id
      })
    },
    {
      path: '/rules',
      name: 'rules',
      component: () => import(/* webpackChunkName: "rules" */ './components/Rules.vue')
    }
  ]
})
